import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Button from "./ui/Button";

export default function LogoutButton() {
    const { logout } = useAuth0();

    // L'appel a /revoke-token a ete retire : la route n'existe pas cote API, et
    // le chemin etait de surcroit RELATIF — il visait le serveur qui sert
    // l'interface, pas l'API. Un .catch(() => {}) masquait le 404 depuis toujours.
    // La deconnexion Auth0 suffit : le jeton d'API expire de lui-meme.
    const handle = () => logout({ logoutParams: { returnTo: window.location.origin } });

    // En rouge et en position fixe, ce bouton était l'élément le plus visible
    // de la page alors qu'il n'est jamais l'action recherchée.
    return (
        <Button variant="ghost" size="sm" onClick={handle}>Déconnexion</Button>
    );
}
